/* ============================================================================
   sdo-douanes-miroir.js — v3.0 (14/08/2026)
   Parfumerie du Soleil d'Or
   ----------------------------------------------------------------------------
   POURQUOI CE FICHIER EXISTE

   Ce script vivait dans le snippet sdo-douanes-panier.liquid, à l'intérieur du
   {%- if show_block and cart.item_count > 0 -%}. Deux conséquences :

     · panier vide au chargement de la page → le snippet ne rend rien, donc le
       script n'est jamais présent ;
     · ajout d'un article ensuite → le tiroir est reconstruit par l'API de
       rendu de section, qui injecte le HTML reçu. Or un <script> injecté de
       cette façon N'EST JAMAIS EXÉCUTÉ par le navigateur (contrairement à un
       <style>, qui lui est bien appliqué — d'où une ligne correctement stylée
       mais jamais déplacée).

   Résultat observé le 14/08/2026 : au premier ajout au panier, la ligne
   « Douane : environ 15,60 £ à régler au transporteur » restait affichée en
   autonome au-dessus de la case CGV, et la phrase de la case ne recevait
   rien. Un simple F5 corrigeait l'affichage — ce qui a confirmé le
   diagnostic, mais ne correspond pas au parcours réel d'un client.

   Chargé en asset depuis theme.liquid, le script existe désormais quel que
   soit l'état du panier, et son MutationObserver prend en charge tous les
   rendus de section ultérieurs.

   LA LOGIQUE ELLE-MÊME EST INCHANGÉE par rapport à la v2.1 du 21/07/2026 :
   recopie du texte du montant dans le <span data-sdo-douanes-target> du MÊME
   bloc panier que la source, puis masquage de la ligne autonome.

     1. SCOPE. On remonte les ancêtres jusqu'au premier qui contienne une
        cible : correct dans le tiroir comme sur la page panier, sans nom de
        classe en dur. Aucune cible trouvée → on ne masque rien.

     2. RIEN À RECOPIER = RIEN À MASQUER. La classe --mirrored n'est posée que
        si un montant a réellement été écrit. Sinon le message qualitatif
        « à régler au transporteur, selon votre pays » disparaîtrait sans rien
        pour le remplacer (pays non chiffré, ou panier sous le seuil de
        minimis).

     3. PREMIER RENDU. Sync relancé sur DOMContentLoaded, sur load, puis
        quelques fois à court intervalle. L'observateur suffit en théorie ;
        ces relances coûtent trois fois rien et couvrent les cas où les
        mutations se tarissent avant que la cible soit posée.

   CSS ASSOCIÉ : .sdo-douanes-panier--mirrored { display: none; } reste dans
   le bloc <style> de sdo-douanes-panier.liquid. Ne pas le déplacer.
   ========================================================================= */

(function () {
  if (window.__sdoDouanesMirror) return;
  window.__sdoDouanesMirror = true;

  /* Plus proche ancêtre de `src` contenant au moins une cible. */
  function scopeFor(src) {
    var node = src.parentElement;
    while (node) {
      if (node.querySelector('[data-sdo-douanes-target]')) return node;
      node = node.parentElement;
    }
    return null;
  }

  function sync() {
    var sources = document.querySelectorAll('[data-sdo-douanes-text]');
    if (!sources.length) return;

    Array.prototype.forEach.call(sources, function (src) {
      var txt = (src.getAttribute('data-sdo-douanes-text') || '').trim();

      /* Rien à chiffrer : on laisse la ligne autonome porter le message
         qualitatif, et on vide la cible si elle traîne un vieux montant. */
      if (!txt) {
        var stale = scopeFor(src);
        if (stale) {
          Array.prototype.forEach.call(
            stale.querySelectorAll('[data-sdo-douanes-target]'),
            function (t) { if (t.textContent) t.textContent = ''; }
          );
        }
        src.classList.remove('sdo-douanes-panier--mirrored');
        return;
      }

      var scope = scopeFor(src);
      if (!scope) {
        /* Cible absente : la ligne autonome reste visible (repli sûr). */
        src.classList.remove('sdo-douanes-panier--mirrored');
        return;
      }

      var targets = scope.querySelectorAll('[data-sdo-douanes-target]');
      var written = false;
      Array.prototype.forEach.call(targets, function (t) {
        var next = ' ' + txt;
        if (t.textContent !== next) t.textContent = next;
        written = true;
      });

      if (written) {
        src.classList.add('sdo-douanes-panier--mirrored');
      } else {
        src.classList.remove('sdo-douanes-panier--mirrored');
      }
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; sync(); });
  }

  var mo = new MutationObserver(schedule);
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });

  sync();
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', sync);
  for (var i = 1; i <= 4; i++) setTimeout(sync, i * 250);
})();